import { render, staticRenderFns } from "./m-info-block.vue?vue&type=template&id=bed536d0&scoped=true&lang=pug"
import script from "./m-info-block.vue?vue&type=script&lang=js"
export * from "./m-info-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed536d0",
  null
  
)

export default component.exports